<template lang="pug">
.other-user-group-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません
    
    // ヘッダー：種類
    template(#head(type)="data")
      .d-flex.flex-row.justify-content-center
        span.help 種類
        HelpIcon(popoverId="other-user-group-type-help" title="施設関係者の種類について")
          template(v-slot:text)
            span オンライン面会に使用するスマートフォンは「施設」を使用してください。
            br
            span オンライン面会の案内転送で選択可能なのは「施設」のみです。

    // セル：ユーザー
    template(#cell(member)="row")
      .d-flex.flex-row.justify-content-center.align-items-center
        .member-count.text-center
          span {{ row.item.memberCount }}人
        .member-detail.text-center
          button.btn.member-detail-btn.disable(v-if="row.item.memberCount <= 0" type="button" disabled) 詳細
          button.btn.member-detail-btn(v-else @click="onShowMembers(row.item)" type="button") 詳細
    // セル：ID通知書
    template(#cell(print)="row")
      button.btn.print-btn(@click="onGuide(row.item)" type="button") 印刷
    // セル：登録情報
    template(#cell(operation)="row")
      button.btn.edit-btn(@click="onEdit(row.item)" type="button") 修正
      button.btn.delete-btn(@click="onDelete(row.item)" type="button") 削除
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * 施設関係者テーブルコンポーネント
 */
@Component({
  components: {
    HelpIcon
  }
})
export default class OtherUserGroupTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OtherUserGroupTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OtherUserGroupTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<OtherUserGroupTableItem> {
    return this.value;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: OtherUserGroupTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(row, filter);
  }

  public filterSearchWords(row: OtherUserGroupTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundGroupName: boolean = true;
    for (const word of words) {
      if (row.name.indexOf(word) == -1) {
        foundGroupName = false;
      }
    }

    let foundType: boolean = true;
    for (const word of words) {
      if (row.type.indexOf(word) == -1) {
        foundType = false;
      }
    }

    return foundGroupName || foundType;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onShowMembers(otherUserGroup: OtherUserGroupTableItem): void {
    this.$emit("onShowMembers", otherUserGroup);
    return;
  }

  /**
   * ### 印刷ボタン押下イベント
   */
  public onGuide(otherUserGroup: OtherUserGroupTableItem): void {
    this.$emit("onGuide", otherUserGroup);
    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(otherUserGroup: OtherUserGroupTableItem): void {
    this.$emit("onEdit", otherUserGroup);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(otherUserGroup: OtherUserGroupTableItem): void {
    this.$emit("onDelete", otherUserGroup);
    return;
  }
}

/** テーブルの列名の情報 */
export interface OtherUserGroupTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OtherUserGroupTableItem {
  facilityId: number;
  id: number;
  groupTypeId: number;
  type: string;
  name: string;
  memberCount: number;
  password: string;
  updated: number;
}

export interface FilterSetting {
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.other-user-group-table-component {
  .member-detail-btn,
  .print-btn,
  .edit-btn,
  .delete-btn {
    width: 64px;
  }
  .edit-btn {
    margin-right: 12px;
  }

  .member-count {
    width: 80px;
  }
  .member-detail {
    width: 100px;
  }

  .help {
    margin-right: 4px;
  }
}
</style>
